<div class="loginDisplay t-{{activeTheme.theme}}" (keyup.enter)="connectT()">
    <div class="connectObjs">
        <div class="column inputFields">
            <mat-form-field class="loginDisplayFormField">
                <input matInput placeholder="{{ 'TERMINAL_ID' | translate }}" [(ngModel)]="id">
            </mat-form-field>
            <mat-form-field class="loginDisplayFormField">
                <input matInput placeholder="{{ 'TERMINAL_PASSWORD' | translate }}" type=password [(ngModel)]="pw">
            </mat-form-field>
        </div>
        <button class="connectButton" mat-raised-button color="primary" (click)="connectT()">{{ 'CONNECT' | translate }}</button>
    </div>
    <div class="loginMessageBlock">
        <div class="loginTextMessage" [hidden]="!textMessageShow">
            {{textMessage}}
        </div>
    </div>
</div>
